export interface BdExportAsFileDialogHubspotContactData {
  email: string;
  firstname: string;
  lastname: string;
  mobilephone: string;
  company: string | null;
  privacyConsent: boolean;
}

export class BdExportAsFileDialogFormHubspotContact {
  constructor(
    public data: BdExportAsFileDialogHubspotContactData,
    public formValid = false,
  ) {}

  public dataIsValid(): boolean {
    return this.formValid;
  }

  public toRequestBody(): { name: string; value: string }[] {
    const fields: { name: string; value: string }[] = [];

    fields.push({
      name: 'email',
      value: this.data.email,
    });

    if (this.data.company) {
      fields.push({
        name: 'company',
        value: this.data.company,
      });
    }

    fields.push({
      name: 'lastname',
      value: this.data.lastname,
    });

    fields.push({
      name: 'firstname',
      value: this.data.firstname,
    });

    fields.push({
      name: 'mobilephone',
      value: this.data.mobilephone,
    });

    return fields;
  }
}
